import { normalizeMarkdownForComparison } from '@eluve/markdown-utils';

// Shared by DiffViewer and SummaryDiffContent. Delegates to
// normalizeMarkdownForComparison — the SAME helper the Levenshtein score
// (ContentSimilarityService) uses — so the diff can never drift from the score.
//
// normalizeMarkdownForComparison runs a full @tiptap/markdown round-trip
// (parse markdown → Tiptap JSON → serialize) per call — not free. The admin diff
// calls this inline in render for every section × both sides, re-running on every
// re-render — a 6-section note is ~12 round-trips per render. The result is
// deterministic in the input, so memoize on the raw text; identical text (same
// section across re-renders, or unchanged sides) reuses the result. Bounded with
// FIFO eviction so a long-lived admin session can't leak. See ENG-4453 / ENG-4659.
const cache = new Map<string, string>();
const MAX_CACHE_ENTRIES = 500;

export const normalizeForDiff = (text: string | undefined | null): string => {
  const input = text ?? '';

  const cached = cache.get(input);
  if (cached !== undefined) {
    return cached;
  }

  const normalized = normalizeMarkdownForComparison(input);

  if (cache.size >= MAX_CACHE_ENTRIES) {
    const oldestKey = cache.keys().next().value;
    if (oldestKey !== undefined) {
      cache.delete(oldestKey);
    }
  }
  cache.set(input, normalized);

  return normalized;
};
